import type { LocalCartInfo } from '@/types';

/**
 * カートの個数を取得
 * @param isLogin ログインしているかどうか
 * @param cartCount ログインしている場合のカートの個数
 * @param cartInfo ログインしていない場合のカートの情報
 * @returns カートの個数
 */
export const getCartCount = (isLogin: boolean, cartCount: number, cartInfo?: LocalCartInfo) => {
  if (isLogin) {
    return cartCount;
  }

  return cartInfo?.items?.length ?? 0;
};
